export const BrandEducationReducerInitialState = {
  brandEducationById: {},
  loading: false,
  brandEducation: null,
};
